/** @jsx jsx */

import { useState, useRef, useEffect, useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';
import { css, jsx } from '@emotion/core';
import InfoBtnIcon from 'assets/Info.svg';

interface HProps {
  children?: any;
  info: any;
  style?: object;
}

const InfoBtn = ({ getRef }) => {
  return (
    <div
      ref={ref => getRef(ref)}
      css={css`
        width: 13px;
        height: 13px;
        background: url('${InfoBtnIcon}') no-repeat;
        background-size: 13px;
        background-position: center;
        cursor: pointer;

        overflow: hidden:

        &:hover {
          opacity: 0.8;
        }
  `}
    />
  );
};

const InfoBubble = ({ info, position }) => {
  const infoBubble = useRef<any>(null);
  const content = useRef<any>(null);

  useLayoutEffect(() => {
    const scrollHeight = `${content.current.scrollHeight + 30}px`;
    // console.log({ scrollHeight });

    infoBubble.current.style.height = scrollHeight;
  }, []);

  return (
    <div
      ref={infoBubble}
      className="fader_-2s"
      css={css`
        position: fixed;
        left: ${position.x}px;
        top: ${position.y}px;
        bottom: 20px;
        max-width: 300px;
        padding: 15px;
        transform: translateZ(0);
        border-radius: 5px;
        font-size: 12px;
        font-weight: 300;
        color: #fff;
        background: #10cfc9;
        box-shadow: 0 0 12px 3px rgba(0, 0, 0, 0.15);
      `}
    >
      <div ref={content}>{info}</div>
    </div>
  );
};

const Info = ({ children, info, style = {}, ...props }: HProps) => {
  const [showInfo, setShowInfo] = useState(false);

  const infoContainer = useRef<any>(null);
  const infoBtn = useRef<any>(null);
  const position = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const hideInfo = () => {
      setShowInfo(false);

      document.removeEventListener('click', hideInfo);
      editorContainer.removeEventListener('scroll', hideInfo);
    };

    showInfo &&
      requestAnimationFrame(() => document.addEventListener('click', hideInfo));

    const editorContainer = document.querySelector('#editor-container')!;
    editorContainer.addEventListener('scroll', hideInfo);

    return () => {
      document.removeEventListener('click', hideInfo);
      editorContainer.removeEventListener('scroll', hideInfo);
    };
  }, [showInfo]);

  return (
    <div
      ref={infoContainer}
      css={css`
        position: relative;
        display: flex;
        align-items: center;
        font-size: 12px;
        line-height: 18px;
        color: #28292b;
      `}
      style={{
        ...style,
      }}
      {...props}
      onClick={() => {
        const {
          left: l0,
          top: t0,
        } = infoContainer.current!.getBoundingClientRect();
        const { left: l1, top: t1 } = infoBtn.current!.getBoundingClientRect();

        position.current = {
          x: l1 + (l0 / 2 + 2.5),
          y: t1,
        };

        setShowInfo(!showInfo);
      }}
    >
      <div
        css={css`
          margin: 0 5px 0 0;
        `}
      >
        {children}
      </div>
      <InfoBtn getRef={ref => (infoBtn.current = ref)} />
      {showInfo &&
        createPortal(
          <InfoBubble info={info} position={position.current} />,
          document.querySelector('#modal-container')!
        )}
    </div>
  );
};

export default Info;
